module.exports = __webpack_public_path__ + "static/media/replace_bfdl.4965da20.svg";